import { chakra, Text } from '@stockx/ui';

export const TruncatedText = chakra(Text, {
  baseStyle: {
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
});

export const LowestAskLabel = chakra(Text, {
  baseStyle: {
    color: 'neutral.500',
    textTransform: 'capitalize',
    fontSize: 'xs',
    fontWeight: 'medium',
    marginTop: '1',
  },
});

export const LowestAskAmount = chakra(Text, {
  baseStyle: {
    color: 'neutral.black',
    fontSize: ['md', 'xl'],
    fontWeight: 'bold',
    lineHeight: '1.3',
    whiteSpace: 'nowrap',
  },
});
